import useApp from 'hooks/useApp'
import Lib from 'library'
import Global from 'library/Global'
import { useNavigate } from 'react-router-dom'
import Native from 'library/native'
import { detailResultDataState, reqCdState, transmitRequestState, selectedOrgsState, certFromState, certTxIdState, resultDataState, checkedResultDataState } from 'views/data/states'
import { manageResultState } from 'views/mydata/manage/states'
import { checkMyDataLinkState, myDataLinkResultUrlState } from 'states'
import {  useRecoilValue, useSetRecoilState, useRecoilCallback } from 'recoil'

const useCertifications = () => {

	const App = useApp()
	const navigate = useNavigate()
	const selectedOrgs = useRecoilValue(selectedOrgsState)
	
	const certFrom = useRecoilValue(certFromState)
	const setCertTxId = useSetRecoilState(certTxIdState)
	const transmitRequest = useRecoilValue(transmitRequestState)

	const setResultData = useSetRecoilState(resultDataState)

	const setDetailResultData = useSetRecoilState(detailResultDataState)
	const manageResult = useRecoilValue(manageResultState)

	// 마데 연동 완료 state
	const setCheckMyDataLink = useSetRecoilState(checkMyDataLinkState)
	const setMyDataLinkResultUrl = useSetRecoilState(myDataLinkResultUrlState)
	
	const getinsttList = () => {
		if(certFrom === "detail"){
			return selectedOrgs.map(org => ({
				insttCd: org.insttCd,
				indstCd: org.indstCd
			}))
		}else{
			return manageResult.map(org => ({
				insttCd: org.insttCd,
				indstCd: org.indstCd,
				targetInfo: org.targetInfoList.map(target => {
					const { assetList, ...rest } = target
					return {
						...rest,
						assetList: assetList
					}
				})
			}))
		}
	}
	// 전송오구권 만들기 - 마이데이터 2.0 관련 전송요구권 파라미터 생성으로 수정
	const getConsentParams =  useRecoilCallback(({snapshot}) => async () => {
		const transmitRequest = await snapshot.getPromise(transmitRequestState)
		const consentParams = {
			isScheduled: transmitRequest.isScheduled === true ? "true" : "false",
			fndCycle: transmitRequest.isCycle ? transmitRequest.isCycle : "1/1w",
			endTerms: transmitRequest.endTerms,
			purpose: "상세정보 전송요구를 위한 가입상품목록 조회",
			insttList: getinsttList(),
		}
		if(!Lib.isNull(transmitRequest.memo)) {
			consentParams.isConsentTransMemo = transmitRequest.memo
		}
		if(!Lib.isNull(transmitRequest.regno)) {
			consentParams.isConsentMerchantNameRegno = transmitRequest.regno
		}
		if(!Lib.isNull(transmitRequest.category)) {
			consentParams.isConsentTransCategory = transmitRequest.category
		}
		return consentParams;
	})

	// 공동인증
	const goCommonCert = () => {
		if (certFrom !== "modify" && !selectedOrgs || selectedOrgs.length < 1) {
			App.alert("선택된 기관이 없습니다.")
			return
		}

		// 인증서 목록 보이기
		Native.execute("Cert", "showCertList", async result => {
			const json = JSON.parse(result)
			const oneWeekLater = new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 7))
			if (json.resultCode === "0") {
				const ucpidData = []
				let listToLoop
				if (certFrom === "detail") {
					listToLoop = selectedOrgs
				} else {
					listToLoop = selectedOrgs
				}
				App.showLoading()
				const consentParams = await getConsentParams()
				let consent;
				await  Lib.axios({
					url: '/api/data/v2/link/consent/list/v2',
					method: "post",
					timeout: 1000 * 180,
					data: consentParams,
					onSuccess: data => {
						console.log(data)
						consent = data;
						
					},
					onComplete: () => {
						App.hideLoading()
					},
					onError: error => {
						console.log(`${error}`);
					}
				})
				for(const org of listToLoop) {
					
					if(typeof consent == 'undefined') {
						console.log("certFrom", certFrom)
						App.alert(`연동 처리시 오류가 발생했습니다.<br />잠시 후 다시 진행하시기 바랍니다.`)
						return;
					}
					ucpidData.push({
						orgCode: org.insttCd,
						end_date: Lib.dateFormat(oneWeekLater, ""),
						ucpidRequestInfo: {
							userAgreement: "금융분야 마이데이터 통합인증을 위한 인증서 본인 확인서비스 이용약관, 개인정보 처리, 고유식별정보 수집·이용 및 위탁에 동의합니다.",
							userAgreeInfo: {
								realName: true,
								gender: true,
								nationalInfo: true,
								birthDate: true,
								ci: true
							},
							ispUrlInfo: "myapidev.moneey.co.kr",
							ucpidNonce: ""
						},
						consentInfo: {
							consent: consent.consentList.find(item => item.snd_org_code === org.insttCd),
							consentNonce: ""
						}
					})
				}
				

				console.log({ ucpidData })

				Native.execute("UCPID", "UCPIDSignData", result => {
					try {
						const json = JSON.parse(result)
						if (json.resultCode === "0") {
							const signedDataList = json.result.ucpid.signedDataList
							const caOrg = json.result.ucpid.caOrg
							const nonce = json.result.nonce
							let params = {
								clsfcCode: "",
								signedList:[]
							}
							if(certFrom == "extend"){
								params.clsfcCode = "EXPND";
							}else if(certFrom == "modify"){
								params.clsfcCode = "CHNG";
							}
							for (let i = 0; i < signedDataList.length; i++) {
								params.signedList.push({
									orgCode:signedDataList[i].orgCode,
									caCode: caOrg,
									signedPersonInfoReq:signedDataList[i].signedPersonInfoReq,
									signedPersonInfoReqLen:signedDataList[i].signedPersonInfoReq.length,
									password:signedDataList[i].signedConsent,
									passwordLen:signedDataList[i].signedConsent.length,
									consentNonce:nonce[i].consentNonce,
									ucpidNonce:nonce[i].ucpidNonce,
								})
							}
							
							// App.showLoading()
							// loading대신 로딩화면으로 전환 필요.
							setCheckMyDataLink(false) // 마데 연동 대기 상태

							Lib.axios({
								url: "/api/data/link/intgr/auth/cert/sign/request/v2",
								method: "post",
								timeout: 1000 * 180,
								data: params,
								onSuccess: data => {
									console.log(data)
									const currentPath = window.location.pathname;
									let url
									if (certFrom === "detail" || certFrom === "modify") {
										setDetailResultData(data)
										url = "/data/detailLinkResult"
									} else if (certFrom === "extend") {
										setResultData(data)
										url = "/mydata/manageResult"
									} else {
										setResultData(data)
										url = "/data/dataLinkResult"
									}
									if(currentPath === "/data/DataGifLoading"){
										setCheckMyDataLink(undefined) // 마데 연동 state 초기화
										navigate(url)
									}else {
										setMyDataLinkResultUrl(url) // 마데 연동 완료 확인
										setCheckMyDataLink(true) // 마데 연동 완료 확인
									}
								},
								onComplete: () => {
									App.hideLoading()
								},
								onError: error => {
									console.log(`${error}`);
									setCheckMyDataLink(undefined) // 마데 연동 state 초기화
									App.alert(`연동 처리시 오류가 발생했습니다.<br />잠시 후 다시 진행하시기 바랍니다.`,()=>navigate('/'))
									return;
								}
							})
							navigate("/data/DataGifLoading")
						} else {
							App.alert(`${json.resultCode}: 에러가 발생했습니다.`)
						}
					} catch (error) {
						App.alert(`${error.name}: ${error.message}`)
					}

				}, { key: JSON.stringify(ucpidData) })


			} else if (json.resultCode === "2") {
				/* 창 취소 */
			} else {
				App.showAlert(`${json.resultCode}: 에러가 발생했습니다.`)
				console.log(json.resultCode)
			}
		}, {
			input_type: '1', // 0 or n :number , 1 or c : character , 2 or s : serial, 3 or a : 인증서
			type: "1", // "type" : "0"(일반 보안 입력 키패드) or "1"(인증서비밀번호) or "2"(주민등록번호) or "3"(입력+주민번호)
			nfilter: { // nFilter 옵션
				public_key: "MDIwGhMABBYCACB19VlS754wwUAdImm7bytbXcxLBBT0KP7JpUvB/tUgV+WiMZAMM8SkfQ==",
				max_length: 50, // int 입력값 최대 자릿수(최대:64)
				desc: '인증서비밀번호' // activity 방식에서 상단에 Input Box 위에 있는 텍스트
			}
		})
	}

	// 사설인증 (네이버)
	const goNaverCert = async () => {
		if (certFrom !== "modify" && !selectedOrgs || selectedOrgs.length < 1) {
			App.alert("선택된 기관이 없습니다.")
			return
		}

		let params = {
			deviceCode: "MO",
			deviceBrowser: "HY",
		}
		const consentParams = await getConsentParams()
		params = {...params,...consentParams}
		App.showLoading()
		setCheckMyDataLink(false) // 마데 연동 대기 상태
		Lib.post({
			url: "/api/data/link/intgr/auth/private/sign/request/v2",
			timeout: 1000 * 180,
			data: params,
			headers: {
				"Content-Type": "application/json;charset=UTF-8"
			},
			onSuccess: data => {
				handleNaverRequest(data)
			},
			onFail: (res) => {
				console.log('onFail',`${res}`)
				setCheckMyDataLink(undefined) // 마데 연동 state 초기화
				Global.alert(`${res.data.msg??"연동 처리시 오류가 발생했습니다.<br />잠시 후 다시 진행하시기 바랍니다."}`,()=>navigate(-1))
	  
			},
			onError:(res) =>{
				console.log('onError',`${res}`)
				setCheckMyDataLink(undefined) // 마데 연동 state 초기화
				Global.alert(`${res.data.msg??"연동 처리시 오류가 발생했습니다.<br />잠시 후 다시 진행하시기 바랍니다."}`,()=>navigate(-1))

			}
		})
		return;	
	}
	
	

	// 네이버 리퀘스트 응답 처리하기
	const handleNaverRequest = data => {
		let url
		if (Native.getUserAgent() === "ios") {
			url = data.signIosAppSchemeUrl
		} else {
			url = data.signAosAppSchemeUrl
		}

		setCertTxId(data.certTxId)
		Native.execute("AppManager", "openScheme", res => {
			const json = JSON.parse(res)

			if (json.resultCode === "1") {
				App.showAlert({
					msg: `네이버인증 앱이 설치되지 않았거나 버전이 낮습니다. 설치화면으로 이동하시겠습니까?`,
					confirm: true,
					ok: "확인",
					cancel: "취소",
					onOk: () => {
						App.hideLoading()
						if (App.device.os.toLowerCase() === "android") {
							Native.execute("AppManager", "openScheme", function (result) { console.log(JSON.parse(result).result) }, { url: "https://play.google.com/store/apps/details?id=com.nhn.android.search" })
						} else {
							Native.execute("AppManager", "openScheme", function (result) { console.log(JSON.parse(result).result) }, { url: "itms-apps://itunes.apple.com/kr/app/apple-store/id393499958?mt=8" })
						}
					},
					onCancel: () => {
						App.hideLoading()
						// navigate("/data/selectCertType")
					},
				})
			}
			console.log(res)
		}, { url: url })
		// App.js wakeup 으로
	}

	// 개별 인증
	const goIndividualCert = () => {
		if (certFrom !== "modify" && selectedOrgs.length < 1) {
			App.alert("선택된 기관이 없습니다.")
			return
		}

		let url = `${App.server}/api/auth/authorize?org_code=${selectedOrgs[0].insttCd}`
		Native.execute("Popup", "openPopup", () => { }, {
			view_id: "individual_cert_pop",
			url: url,
			title: `${App.appName} 개별인증`
		})
	}

	// testBed 인증
	const goTestBedCert = async () => {
		if (certFrom !== "modify" && !selectedOrgs || selectedOrgs.length < 1) {
			App.alert("선택된 기관이 없습니다.")
			return
		}

		let params = {
			deviceCode: "MO",
			deviceBrowser: "HY",
		}
		const consentParams = await getConsentParams()
		params = {...params,...consentParams}
		setCheckMyDataLink(false) // 마데 연동 대기 상태
		Lib.post({
			url: "/api/data/link/intgr/auth/testbed",
			
			onSuccess: (data) => {
				const currentPath = window.location.pathname;
				let url
				if (certFrom === "detail" || certFrom === "modify") {
					setDetailResultData(data)
					url = "/data/detailLinkResult"
				} else if (certFrom === "extend") {
					setResultData(data)
					url = "/mydata/manageResult"
				} else {
					setResultData(data)
					url = "/data/dataLinkResult"
				}
				if(currentPath === "/data/DataGifLoading"){
					setCheckMyDataLink(undefined) // 마데 연동 state 초기화
					navigate(url)
				}else {
					setMyDataLinkResultUrl(url) // 마데 연동 완료 확인
					setCheckMyDataLink(true) // 마데 연동 완료 확인
				}
			},
			onFail: (res) => {
				setCheckMyDataLink(undefined) // 마데 연동 state 초기화
				App.alert(`연동 처리시 오류가 발생했습니다.<br />잠시 후 다시 진행하시기 바랍니다.`,()=>navigate('/'))

				console.log('onFail',`${res}`)
				
			},
			data: params,
			onError:(res) =>{
				setCheckMyDataLink(undefined) // 마데 연동 state 초기화
				App.alert(`연동 처리시 오류가 발생했습니다.<br />잠시 후 다시 진행하시기 바랍니다.`,()=>navigate('/'))

				console.log('onError',`${res}`)
			},
			timeout: 1000 * 300,
		});
		navigate("/data/DataGifLoading")

		// let params = [];

		// selectedOrgs.map((item) => {
		// 	params.push({
		// 	ca_code: "",
		// 	clsfc_code: "",
		// 	consent_nonce: "",
		// 	org_code: item.insttCd,
		// 	password: "",
		// 	password_len: 0,
		// 	signed_person_info_req: "",
		// 	signed_person_info_req_len: 0,
		// 	ucpid_nonce: "",
		// 	});
		// });

		// if (params.length > 0) {
		// 	// App.showLoading();
		// 	await Lib.post({
		// 	url: "/api/data/lnkup/testbed/step1",
		// 	data: params,
		// 	onSuccess: (data) => {
		// 		console.log("step1 호출 data");
		// 	},
		// 	});

		// 	// App.showLoading();
		// 	// loading대신 로딩화면으로 전환 필요.
		// 	setCheckMyDataLink(false) // 마데 연동 대기 상태
			
		// 	// api 호출 결과를 대기하지 않고 호출 후 아래 navigate로 페이지 바로 이동. 
		// 	Lib.post({
		// 	url: "/api/data/lnkup/testbed/step2",
		// 	data: params,
		// 	onSuccess: async data => {
				
		// 		const currentPath = window.location.pathname;
		// 		let url
		// 		if (certFrom === "detail" || certFrom === "modify") {
		// 			setDetailResultData(data)
		// 			url = "/data/detailLinkResult"
		// 		} else if (certFrom === "extend") {
		// 			setResultData(data)
		// 			url = "/mydata/manageResult"
		// 		} else {
		// 			setResultData(data)
		// 			url = "/data/dataLinkResult"
		// 		}
		// 		if(currentPath === "/data/DataGifLoading"){
		// 			setCheckMyDataLink(undefined) // 마데 연동 state 초기화
		// 			navigate(url)
		// 		}else {
		// 			setCheckMyDataLink(true) // 마데 연동 완료 확인
		// 			setMyDataLinkResultUrl(url) // 마데 연동 완료 확인
		// 		}
		// 	},
		
		// 	});
		// 	navigate("/data/DataGifLoading")
		// } else {
		// 	App.showAlert("선택 된 기관이 없습니다.");
		// }
	}

	return { getConsentParams, goCommonCert, goNaverCert, goIndividualCert, goTestBedCert }
}

export default useCertifications